type LoaderProps = {
  message?: string;
  className?: string;
};

export default function Loader({ message = "Loading...", className = "" }: LoaderProps) {
  return (
    <div className={`flex h-full min-h-[200px] w-full items-center justify-center ${className}`}>
      <div className="flex flex-col items-center gap-4">
        <div className="h-12 w-12 animate-spin rounded-full border-4 border-theme-border border-t-theme-primary" />
        <p className="animate-pulse text-sm font-semibold text-theme-text-soft">{message}</p>
      </div>
    </div>
  );
}
